var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKontakt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.75H7C2.59 21.75 1.25 20.41 1.25 16V8C1.25 3.59 2.59 2.25 7 2.25H17C21.41 2.25 22.75 3.59 22.75 8V16C22.75 20.41 21.41 21.75 17 21.75ZM7 3.75C3.42 3.75 2.75 4.43 2.75 8V16C2.75 19.57 3.42 20.25 7 20.25H17C20.58 20.25 21.25 19.57 21.25 16V8C21.25 4.43 20.58 3.75 17 3.75H7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.75H14C13.59 8.75 13.25 8.41 13.25 8C13.25 7.59 13.59 7.25 14 7.25H19C19.41 7.25 19.75 7.59 19.75 8C19.75 8.41 19.41 8.75 19 8.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.75H15C14.59 12.75 14.25 12.41 14.25 12C14.25 11.59 14.59 11.25 15 11.25H19C19.41 11.25 19.75 11.59 19.75 12C19.75 12.41 19.41 12.75 19 12.75Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.75H17C16.59 16.75 16.25 16.41 16.25 16C16.25 15.59 16.59 15.25 17 15.25H19C19.41 15.25 19.75 15.59 19.75 16C19.75 16.41 19.41 16.75 19 16.75Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49994 12.04C7.08994 12.04 5.93994 10.89 5.93994 9.47998C5.93994 8.06998 7.08994 6.91998 8.49994 6.91998C9.90994 6.91998 11.0599 8.06998 11.0599 9.47998C11.0599 10.89 9.90994 12.04 8.49994 12.04ZM8.49994 8.41998C7.91994 8.41998 7.43994 8.89998 7.43994 9.47998C7.43994 10.06 7.91994 10.54 8.49994 10.54C9.07994 10.54 9.55994 10.06 9.55994 9.47998C9.55994 8.89998 9.07994 8.41998 8.49994 8.41998Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.08C11.62 17.08 11.29 16.79 11.25 16.4C11.14 15.32 10.27 14.45 9.18003 14.35C8.72003 14.31 8.26003 14.31 7.80003 14.35C6.71003 14.45 5.84003 15.31 5.73003 16.4C5.69003 16.81 5.32003 17.12 4.91003 17.07C4.50003 17.03 4.20003 16.66 4.24003 16.25C4.42003 14.45 5.85003 13.02 7.66003 12.86C8.21003 12.81 8.77003 12.81 9.32003 12.86C11.12 13.03 12.56 14.46 12.74 16.25C12.78 16.66 12.48 17.03 12.07 17.07C12.05 17.08 12.02 17.08 12 17.08Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontakt);
export default __webpack_public_path__ + "static/media/kontakt.d56ff7807ea0525784a8632fd49276fe.svg";
export { ForwardRef as ReactComponent };